<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
       <span
           class="main-r_top_nav"
           :class="mainStatus === 'online' && 'active'"
           @click.stop="handleClick('online')"
       >{{$t('apiDoc.在线文档')}}</span>
      <span
          class="main-r_top_nav"
          :class="mainStatus === 'apiTest' && 'active'"
          @click.stop="handleClick('apiTest')"
      >{{$t('apiDoc.测试工具')}}</span>
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'online'">
      <online-doc :onlineData="onlineData"></online-doc>
    </div>
    <!-- 在线文档 END -->
    <!-- 测试工具 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'apiTest'">
      <api-test-doc :apiTestData="apiTestData"></api-test-doc>
    </div>
    <!-- 测试工具 END -->
  </div>
</template>

<script>
import onlineDoc from "../components/onlineDoc";
import apiTestDoc from "../components/apiTestDoc";
import {OPEN_API_TEST,OPEN_API_PRO} from '@/constants/index'
const apiUrlTest = 'bill/lading/query';
export default {
  components: { onlineDoc , apiTestDoc },
  data() {
    return {
      mainStatus: "online",
      //当前请求URL
      apiBaseUrl: process.env.VUE_APP_API_URL + `/${apiUrlTest}`,

      onlineData: {
        //接口描述
        apiDesc: `${this.$t('onlineDoc.支持查询清关单对应的提单状态及小包(运单)状态信息')}`,
        //接口地址
        testApi: `${OPEN_API_TEST}/${apiUrlTest}`,
        proApi: `${OPEN_API_PRO}/${apiUrlTest}`,
        postDataList:[
          {
            title:'Headers',
            value:[
              {name: "apiAccount",type: "Number",require: "Y",normal: "",describe: `${this.$t('onlineDoc.接入方在平台的api账户标识')}`, },
              {name: "timestamp",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.时间戳')}`,},
              {name: "digest",type: "Number",require: "Y",normal: "",describe: `${this.$t('onlineDoc.签名字符串')}`, },
              {name: "digestType",type: "Number",require: "N",normal: "",describe: `${this.$t('onlineDoc.签名类型')}`, },
            ]
          },
          {
            title:`${this.$t('onlineDoc.请求参数')}`,
            value:[
              {name: "bizContent",type: "String",require: "Y",normal: '',describe: `${this.$t('onlineDoc.业务参数')}`,},
            ]
          },
          {
            title:`${this.$t('onlineDoc.业务参数')}`,
            value:[
              {name: "customerCode",type: "String",require: "Y", normal: "", describe:`${this.$t('onlineDoc.客户编码')}`},
              {name: "queryCode",type: "String(30)",require: "Y", normal: "lad0425614590", describe:`${this.$t('onlineDoc.业务数据（提单号、运单号、大包号）')}`},
              {name: "queryCodeType",type: "String(30)",require: "Y", normal: "1", describe:`${this.$t('onlineDoc.业务枚举')}`}
            ],
          }
        ],
        responseDataList:[
          {
            title:`${this.$t('onlineDoc.响应参数')}`,
            value:[
              { name: "code",type: "String", require: "Y",normal: "",describe: `${this.$t('onlineDoc.返回码')}`,},
              {name: "msg",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.描述')}`,},
              {name: "data",type: "Object",require: "N",normal: "",describe: `${this.$t('onlineDoc.业务数据')}`,},
            ]
          },
          {
            title:`${this.$t('onlineDoc.data类型说明')}`,
            value:[
              {name: "masterWaybillNo",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.提单号')}`,},
              {name: "statusCode",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.提单状态code')}`,},
              {name: "statusName",type: "String(50)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.提单状态')}`,},
              {name: "largePacketList",type: "List<BillLadingRelationVO>",require: "Y",normal: "",describe: `${this.$t('onlineDoc.大包对象集合')}`,}
            ]
          },
          {
            title:`${this.$t('onlineDoc.大包对象说明<BillLadingRelationVO>')}`,
            value:[
              {name: "bigBagNo",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.大包号')}`,},
              {name: "packetList",type: "List<CustomsPackageRelationVO>",require: "Y",normal: "",describe: `${this.$t('onlineDoc.小包集合')}`,}
            ]
          },
          {
            title:`${this.$t('onlineDoc.小包对象说明<CustomsPackageRelationVO>')}`,
            value:[
              {name: "trackingNo",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.运单号')}`,},
              {name: "trackingStatusCode",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.运单状态code')}`,},
              {name: "trackingStatusName",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.运单状态')}`,}
            ]
          }

        ],
        //请求示例
        requestCode: `Header：
     apiAccount=292508153084379141
     Content-Type=application/x-www-form-urlencoded
     digest=djEINdkT7aLeivrvhf91SQ==
     timestamp=1648536570679

 Body：
     bizContent = {"customerCode":"J0086024173","queryCode":"LDG2025924547407","queryCodeType":"1"}`,
        //返回示例
        responseCode: JSON.parse(`{
  "code": "1",
  "msg": "success",
  "data": {
    "masterWaybillNo": "LDG2025163875028",
    "statusCode": "1000",
    "statusName": "Pending declaration",
    "largePacketList": [
      {
        "bigBagNo": "BIGBAG2025312030",
        "packetList": [
          {
            "trackingNo": "UTE019039002619",
            "trackingStatusCode": "1003",
            "trackingStatusName": "Completed Clearance"
          }
        ]
      },
      {
        "bigBagNo": "BIGBAG2025908763",
        "packetList": [
          {
            "trackingNo": "UTE019039077709",
            "trackingStatusCode": "1001",
            "trackingStatusName": "To be Cleared"
          }
        ]
      }
    ]
  }
}`),

        //错误代码提示
        errcodeJson: []
      },

      apiTestData: {
        _headerData: {
          apiAccount: "292508153084379141",
          digest: "U40e5sumorgd3YgZzU61Mw==",
          timestamp: "1565238848921",
        },
        data:{
          bizContent: `{"customerCode":"J0086024173","queryCode":"LDG2025924547407","queryCodeType":"1"}`,
        },
        //必须要验证的参数
        requestData:['apiAccount','digest','timestamp','bizContent'],
        textareaData:{
          bizContent:true
        },
        //促发接口
        apiUrl: `/mock/${apiUrlTest}`,
        //返回
        ResponseJson: "",
        //当前请求URL
        apiBaseUrl: process.env.VUE_APP_API_URL + `/mock/${apiUrlTest}`,
        //错误代码提示
        errcodeJson: []
      },
    };
  },
  created() {},
  methods: {
    handleClick(status) {
      this.mainStatus = status;
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../css/apiTest.scss";
</style>